import { FC } from 'react';
import { sortBy, uniq } from 'lodash';
import { useTranslation } from 'react-i18next';
import useCreateRedditReport from 'wb-reddit/app/routes/reports/create/useCreateRedditReport';
import {
	BreakdownList, ButtonColor, Checkbox, Dropdown, Label, Menu,
} from '@aleph/shared-components';
import {
	SPOTIFY_REPORT_BREAKDOWN_OPTIONS_CATEGORIZED,
	SPOTIFY_REPORT_BREAKDOWN_OPTIONS_LIFETIME,
	SPOTIFY_REPORT_COL_DEFS,
} from 'wb-spotify/app/routes/utils';
import useSupergridSettings from 'wb-spotify/app/routes/superGrid/hooks/useSupergridSettings';

const MAX_BREAKDOWNS = 5;

const SpotifyReportsBreakdownSelector: FC = () => {
	const { t } = useTranslation();
	const { lifetimeStats } = useSupergridSettings();

	const { breakdowns, setBreakdowns } = useCreateRedditReport();

	const isBreakdownChecked = (breakdownValue: string) => breakdowns.includes(breakdownValue);

	const changeBreakdownSelection = (breakdown: string) => {
		setBreakdowns(currBreakdowns => sortBy(
			uniq([...currBreakdowns, breakdown])
				.filter(currBreakdown => !isBreakdownChecked(breakdown) || currBreakdown !== breakdown),
			currBreakdown => SPOTIFY_REPORT_COL_DEFS.map(colDef => colDef.field).indexOf(currBreakdown),
		));
	};
	// eslint-disable-next-line max-len
	const options = lifetimeStats ? SPOTIFY_REPORT_BREAKDOWN_OPTIONS_LIFETIME : SPOTIFY_REPORT_BREAKDOWN_OPTIONS_CATEGORIZED;

	return (
		<Dropdown
			title={t('re: reports.breakdowns', 'Breakdowns')}
			leftNode={<BreakdownList/>}
			color={ButtonColor.WISE_BLUE}
		>
			<Menu>
				{options.map(
					(breakdown) => {
						// @ts-ignore
						const disabled = (breakdown.exclude ?? []).some(exclusion => breakdowns.includes(exclusion))
              || (breakdowns?.length >= MAX_BREAKDOWNS
                && !isBreakdownChecked(breakdown.value));

						return (
							<Menu.Item
								onClick={() => changeBreakdownSelection(breakdown.value)}
								selected={isBreakdownChecked(breakdown.value)}
								disabled={disabled}
								key={breakdown.value}
							>
								<Checkbox
									onClick={() => changeBreakdownSelection(breakdown.value)}
									checked={isBreakdownChecked(breakdown.value)}
								/>
								<Label>
									{breakdown.label}
								</Label>
							</Menu.Item>
						);
					},
				)}
			</Menu>
		</Dropdown>
	);
};

export default SpotifyReportsBreakdownSelector;
